var SettingsPageController = /** @class */ (function () {
    /*@ngInject*/
    function SettingsPageController($scope, $state, $rootScope, $timeout, $window, $transitions, $uibModal, StorageService, jobService, settingService, userService, companyService, utilityService, alertsAndNotificationsService, MESSAGECONSTANTS, uibModalService, userRoleService) {
        this.$scope = $scope;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$window = $window;
        this.$transitions = $transitions;
        this.$uibModal = $uibModal;
        this.StorageService = StorageService;
        this.jobService = jobService;
        this.settingService = settingService;
        this.userService = userService;
        this.companyService = companyService;
        this.utilityService = utilityService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.uibModalService = uibModalService;
        this.userRoleService = userRoleService;
    }
    SettingsPageController.prototype.$onInit = function () {
        var _this = this;
        this.$stateParams = this.$transition$.params();
        this._initializeVariables();
        if (this.$stateParams.accessMode === null) {
            this.viewOnlyMode = false;
        }
        else {
            this.viewOnlyMode = true;
        }
        this.isVendorCompany = this.companyService.isCompanyVendor();
        this.$window.addEventListener("beforeunload", function () {
            if (angular.equals(_this.$state.$current.name, 'missioncontrol.settings')) {
                _this.StorageService.remove('removeSliderId');
                console.log('now removeSliderId and refreshing');
            }
        });
        this._handleDisableSlider();
        this._handleBrowserBackForwardChange();
        this._getSettings();
        this._getAllActivityTypes();
    };
    SettingsPageController.prototype._initializeVariables = function () {
        this.currentCompany = this.$rootScope.userDetails.company;
        this.form = {};
        this.form.settingsTypeform = {};
        this.form.performanceSetting = {};
        this.globalSettings = null; //Global Settings
        this.settings = {}; //UI Settings
        this.settings.licensePreferenceSetting = {};
        this.settings.performanceSetting = {};
        this.savedSettings = {}; //Saved Settings Object
        this.allClientsOrBus = [];
        this.allClientsOrBusForCopy = null;
        this.allClientsOrBusForCopyHavingCustomSettings = null;
        this.timeInWorkflowSteps = [];
        this.years = [0, 1, 2];
        this.months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        this.days = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
        this.copyChecked = false;
        this.disableCompanyOrClientSettingsSelection = true;
        this.copyClientCheckBox = false;
        this.selectEnable = false;
        this.checkValuesArray = [];
        this.availableClientsToCopy = [];
        this.clientCopy = null;
        this.selectedClientOrBu = {};
        this.selectedClientOrBu.id = null;
        this.isCustomSettingsSelected = false;
        this.delimitedCompanyOrClientName = null;
        this.deleteSettingCounter = 0;
        this.showConfirmationPopup = false;
        this.isClientGlobalCopy = true;
        this.hasAccessToCompanySettings = false;
        this.isValuesInitialized = false;
        this.isCompanySelected = true;
        this.isLocationChange = false;
        this.isLocationChangeInitial = false;
        this.isInHost = this.utilityService.isInHost();
        this.isVendorCompany = false;
        this.globalSettingsCompanyModel = false;
        this.globalSettingsClientModel = false;
        this.isUsersPanelOpen = false;
        this.isRequisitionPanelOpen = false;
        ;
        this.licensePreferencePanelFlags = [];
        this.toggleClientValue = {};
        this.toggleClientValueCopy = {};
        this.companySelectionActive = true;
        this.isClientCopyObject = false;
        this.clientCopyMandatoryMessage = false;
        this.isStillProcessing = true;
        this.isStillProcessingModified = true;
        this.loadingFlag = true;
        this.userRole = this.$rootScope.userDetails.roleScreenRef.role.name;
        this.isStaffingCompany = this.companyService.isStaffingCompany();
        this.isCorporateCompany = this.companyService.isCorporateCompany();
        this.selectedClient = null;
        this.isOutreachPanelOpen = false;
        this.isSuperUserOrAdmin = this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin();
    };
    SettingsPageController.prototype._getSettings = function () {
        var _this = this;
        if (this.isInHost) {
            console.log('Get 4dot5 Settings');
            this.hasAccessToCompanySettings = true;
            this._getFourDotFiveSettings();
        }
        else {
            if ((this.userRole == 'StaffingRecruitingManager' && !this.isVendorCompany) || this.userRole == this.MESSAGECONSTANTS.ROLESNAMES.HIRING_MANAGER || this.userRole == 'CorporateRecruitingManager') {
                this._getClientsOrBus(function () {
                    _this._getLoggedInUserDetails(function () {
                        if (_this.hasAccessToCompanySettings) {
                            _this._getSettingsForStaffingOrCorporateCompany();
                        }
                        else {
                            _this.manageClientOrBuSelection();
                        }
                    });
                });
            }
            else {
                console.log('Get Staffing or corporate company Settings');
                this.hasAccessToCompanySettings = true;
                this._getSettingsForStaffingOrCorporateCompany();
            }
        }
    };
    SettingsPageController.prototype._getFourDotFiveSettings = function () {
        var _this = this;
        this.settingService.getFourDotFiveSettings(function (data) {
            _this.settings = data;
            _this._setReminderSettings();
            if (_this.isInHost) {
                _this.settingsCopyForCompany = angular.copy(data);
            }
            //  this.StorageService.set('removeSliderId', this.settings.performanceSetting.length +1);
            _this.settingsCopy = data;
            _this.globalSettings = angular.copy(_this.settings);
            _this.savedSettings = angular.copy(_this.settings);
            if (_this.$rootScope.userDetails.company.companyType === 'Host') {
                _this.$timeout(function () {
                    /*angular.element('#setvalues').trigger('click');*/
                    _this.setSliderValues();
                    _this.isValuesInitialized = true;
                    _this._isGlobalOrCustomSettings();
                }, 500);
            }
            else {
                for (var i = 0; i < _this.settings.performanceSetting.length; i++) {
                    _this.updateMaxLimitForSliders(i, _this.settings.performanceSetting[i].maxLimit);
                }
                _this._isGlobalOrCustomSettings();
                _this._updateSettingsInView();
            }
            _this.isStillProcessing = false;
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    SettingsPageController.prototype._setReminderSettings = function () {
        angular.forEach(this.settings.licensePreferenceSetting, function (setting, index) {
            if (setting.reminderInterval > 0) {
                setting.defaultReminderInterval = setting.reminderInterval;
                setting.isReminderEnabled = true;
            }
            else {
                setting.defaultReminderInterval = 2;
                setting.isReminderEnabled = false;
            }
        });
    };
    /**
     * Function to update maxlimit for sliders.
     * Range slider is $index starts from 0
     */
    SettingsPageController.prototype.updateMaxLimitForSliders = function (rangeSlider, maxLimit) {
        //     console.log(rangeSlider + 'New maxLimit: ' + maxLimit);
        //     console.log('Presently: ' + this.settings.performanceSetting[rangeSlider].maxLimit);
        if ((maxLimit >= this.settings.performanceSetting[rangeSlider].maxValue) && (maxLimit <= 200) && (this.settings.performanceSetting[rangeSlider].maxValue !== 0)) {
            this.settings.performanceSetting[rangeSlider].isSelected = false;
            this.settings.performanceSetting[rangeSlider].maxLimit = maxLimit;
            var sliderIdInUI = this.settings.performanceSetting.length + rangeSlider + 3;
            console.log('slider changing is : ' + sliderIdInUI);
            this.StorageService.set('removeSliderId', sliderIdInUI);
            /*if(this.isInHost){
            }*/
            // console.log('Removing Slider with Id: ' + sliderIdInUI);
            $('.slider-range-' + rangeSlider).empty();
            var performanceSliderValues = this.settings.performanceSetting;
            //performanceSliderValues[0].maxLimit = maxLimit;
            var sliderClass_1 = '.slider-range-' + rangeSlider;
            $(sliderClass_1).noUiSlider({
                range: [0, maxLimit],
                start: [performanceSliderValues[rangeSlider].minValue, performanceSliderValues[rangeSlider].maxValue],
                step: 1,
                connect: true,
                /*slide: function () {
                    var values = $(sliderClass).val();
                    $(sliderClass).next('span').text(values[0] + ' - ' + values[1]).addClass('sliderBold');
                },
                set: function () {
                    var values = $(sliderClass).val();
                    $(sliderClass).next('span').text(values[0] + ' - ' + values[1]).removeClass('sliderBold');
                    //console.log('Set PerformanceSetting: ' + values[0] + ' - ' + values[1]);
                }*/
                slide: function () {
                    var values = $(sliderClass_1).val();
                    var fromLabel = $(sliderClass_1).next('p').find('.fromLabel').text();
                    var toLabel = $(sliderClass_1).next('p').find('.toLabel').text();
                    if (fromLabel != '' && fromLabel != values[0]) {
                        $(sliderClass_1).next('p').find('.fromLabel').text(values[0]).addClass('sliderBold');
                    }
                    else if (toLabel != '' && toLabel != values[1]) {
                        $(sliderClass_1).next('p').find('.toLabel').text(values[1]).addClass('sliderBold');
                    }
                },
                set: function () {
                    var values = $(sliderClass_1).val();
                    $(sliderClass_1).next('p').find('.fromLabel').text(values[0]).removeClass('sliderBold');
                    $(sliderClass_1).next('p').find('.toLabel').text(values[1]).removeClass('sliderBold');
                }
            });
            // console.log('Updating values for slider: ' + rangeSlider);
            $('.slider-range-' + rangeSlider).val([performanceSliderValues[rangeSlider].minValue, performanceSliderValues[rangeSlider].maxValue], true);
            this.settings.performanceSetting[rangeSlider].isError = false;
            this.settings.performanceSetting[rangeSlider].isErrorForMax = false;
        }
        else {
            if (maxLimit > 200) {
                this.settings.performanceSetting[rangeSlider].isErrorForMax = true;
                this.settings.performanceSetting[rangeSlider].isError = false;
            }
            else {
                this.settings.performanceSetting[rangeSlider].isError = true;
                this.settings.performanceSetting[rangeSlider].isErrorForMax = false;
            }
        }
    };
    /**
     * Setting value and render sliders in UI
     */
    SettingsPageController.prototype.setSliderValues = function () {
        //console.log("setvalues method");
        var sliderValues = this.settings.licensePreferenceSetting;
        var _loop_1 = function (i) {
            //console.log('Score is: ' + sliderValues[i].score);
            if (sliderValues[i].score != null) {
                var sliderClass_2 = '.slider-setting-' + i;
                $(sliderClass_2).noUiSlider({
                    range: [0, 100],
                    start: [sliderValues[i].score],
                    handles: 1,
                    step: 0.5,
                    connect: 'lower',
                    slide: function () {
                        var val = $(sliderClass_2).val();
                        $(sliderClass_2).next('span').text(val).addClass('sliderBold');
                    },
                    set: function () {
                        var val = $(sliderClass_2).val();
                        $(sliderClass_2).next('span').text(val).removeClass('sliderBold');
                    }
                });
                $('.slider-setting-' + i).val(sliderValues[i].score, true);
            }
        };
        for (var i = 0; i < this.settings.licensePreferenceSetting.length; i++) {
            _loop_1(i);
        }
        var _loop_2 = function (i) {
            //console.log('Score is: ' + sliderValues[i].timeToComplete);
            var sliderClass = '.slider-setting-timeToComplete-' + i;
            $(sliderClass).noUiSlider({
                range: [0, 10],
                start: [sliderValues[i].timeToComplete],
                handles: 1,
                step: 1,
                connect: 'lower',
                slide: function () {
                    var val = $(sliderClass).val();
                    $(sliderClass).next('span').text(val).addClass('sliderBold');
                },
                set: function () {
                    var val = $(sliderClass).val();
                    $(sliderClass).next('span').text(val).removeClass('sliderBold');
                }
            });
            $('.slider-setting-timeToComplete-' + i).val(sliderValues[i].timeToComplete, true);
        };
        for (var i = 0; i < this.settings.licensePreferenceSetting.length; i++) {
            _loop_2(i);
        }
        var performanceSliderValues = this.settings.performanceSetting;
        var _loop_3 = function (j) {
            var sliderClass = '.slider-range-' + j;
            $(sliderClass).noUiSlider({
                range: [0, performanceSliderValues[j].maxLimit],
                start: [performanceSliderValues[j].minValue, performanceSliderValues[j].maxValue],
                step: 1,
                connect: true,
                slide: function () {
                    var values = $(sliderClass).val();
                    var fromLabel = $(sliderClass).next('p').find('.fromLabel').text();
                    var toLabel = $(sliderClass).next('p').find('.toLabel').text();
                    if (fromLabel != '' && fromLabel != values[0]) {
                        $(sliderClass).next('p').find('.fromLabel').text(values[0]).addClass('sliderBold');
                    }
                    else if (toLabel != '' && toLabel != values[1]) {
                        $(sliderClass).next('p').find('.toLabel').text(values[1]).addClass('sliderBold');
                    }
                },
                set: function () {
                    var values = $(sliderClass).val();
                    $(sliderClass).next('p').find('.fromLabel').text(values[0]).removeClass('sliderBold');
                    $(sliderClass).next('p').find('.toLabel').text(values[1]).removeClass('sliderBold');
                }
            });
            $('.slider-range-' + j).val([performanceSliderValues[j].minValue, performanceSliderValues[j].maxValue], true);
        };
        for (var j = 0; j < this.settings.performanceSetting.length; j++) {
            _loop_3(j);
        }
        this.loadingFlag = false;
    };
    SettingsPageController.prototype._isGlobalOrCustomSettings = function () {
        this.isStillProcessing = true;
        if (this.settings.global && this.$rootScope.userDetails.company.companyType != 'Host') {
            // angular.element('.slider-range').attr({ 'disabled': true }); //Disabling double headed sliders.
            // angular.element('.noUi-target').attr({ 'disabled': true }); //Disabling single headed sliders.
            // angular.element('.onoffswitch').addClass('avoid-clicks'); //Disabling switches.
        }
        else {
            for (var index = 0; index < this.settings.licensePreferenceSetting.length; index++) {
                if (this.settings.licensePreferenceSetting[index].isEnabled) {
                    angular.element('.slider-setting-' + index).attr({ 'disabled': false });
                    angular.element('.slider-setting-timeToComplete-' + index).attr({ 'disabled': false });
                }
                else {
                    angular.element('.slider-setting-' + index).attr({ 'disabled': true });
                    // angular.element('.slider-setting-timeToComplete-' + index).attr({ 'disabled': true });
                }
            }
        }
        this.isStillProcessing = false;
    };
    SettingsPageController.prototype._getClientsOrBus = function (callback) {
        var _this = this;
        this.isStillProcessing = true;
        console.log('Getting Clients/Bus');
        this.userService.getUsersOnlyClientsOrBus(this.$rootScope.userDetails.company.companyId, function (data) {
            _this.isClientExists = data && data.length > 0;
            _this.allClientsOrBus = angular.copy(data);
            angular.forEach(_this.allClientsOrBus, function (clientOrBu, index) {
                if (clientOrBu.companyType == 'Corporation') {
                    clientOrBu.aliasName = clientOrBu.aliasName + " &#xf1e0;";
                }
            });
            if (_this.allClientsOrBus.length > 0) {
                _this.client = _this.allClientsOrBus[0];
                _this.selectedClientOrBu.id = _this.client.companyId;
                console.log('assigned first client : ' + angular.toJson(_this.client));
                _this.getSettingsForClient(_this.client);
                _this.checkValuesClientsOrBus = data;
                _this.allClientsOrBusForCopy = data;
            }
            else {
                _this.isStillProcessing = false;
                _this.loadingFlag = false;
            }
            if (callback) {
                callback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    SettingsPageController.prototype.getSettingsForClient = function (client) {
        var _this = this;
        this.isStillProcessing = true;
        this.loadingFlag = true;
        this.toggleClientValue = client;
        if (client.companyType === "Client" || client.companyType === "Corporation") {
            this.selectedClientNameForMessage = client.companyName;
        }
        else if (client.companyType === "BusinessUnit") {
            this.selectedBUNameForMessage = client.companyName;
        }
        //if(!this.isClientGlobalCopy){
        //$filter('clientorbuModified')(client.companyName, this.isClientGlobalCopy);
        //}
        this.ischeckboxValueNullorNot = document.getElementById("checkbox-inl-1");
        this.globalSettingsClientModel = false;
        this.client = client;
        if (this.availableClientsToCopy.length != 0) {
            this.availableClientsToCopy = [];
            this.allClientsOrBus.forEach(function (element) {
                if (element.companyId != client.companyId) {
                    _this.availableClientsToCopy.push(element);
                }
                else {
                    console.log('Duplicate : ' + element.companyName + ' not added');
                }
            }, this);
        }
        this.settingService.getClientOrBuSettings(this.$rootScope.userDetails.company.companyId, client.companyId, function (data) {
            _this.settings = data;
            _this._setReminderSettings();
            _this.isClientGlobal = data.global;
            _this.isClientGlobalCopy = _this.isClientGlobal;
            _this.settingsClient = angular.copy(_this.settings);
            _this.savedSettings = angular.copy(_this.settings);
            _this.copyChecked = false;
            _this.isClientCopyObject = false;
            _this.clientCopyMandatoryMessage = false;
            _this.$timeout(function () {
                if (!_this.isValuesInitialized) {
                    _this.setSliderValues();
                    _this.isValuesInitialized = true;
                }
                _this._isGlobalOrCustomSettings();
            }, 500);
            /*for(i=0; i < this.allClientsOrBus.length; i++){
                this.allClientsOrBus[i].clientCompanyNameCopy = this.allClientsOrBus[i].companyName;
            }*/
            //this.client.clientCompanyNameCopy = $filter('clientorbuModified')(this.client.companyName, this.isClientGlobalCopy);
            _this._isGlobalOrCustomSettings();
            _this._updateSettingsInView();
            if (!_this.viewOnlyMode) {
                _this._getClientsOrBusHavingCustomSettings();
            }
            else {
                _this.loadingFlag = false;
            }
            //this.isStillProcessing = false;
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    SettingsPageController.prototype._getLoggedInUserDetails = function (callback) {
        var _this = this;
        this.userService.getLoggedInUserDetails(function (data) {
            if (!data.isBUsOrClientsAvailable) {
                _this.hasAccessToCompanySettings = true;
                if (callback) {
                    callback();
                }
            }
            if (!_this.hasAccessToCompanySettings) {
                _this._isUserEntityScopeAll(function () {
                    if (callback) {
                        callback();
                    }
                });
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    SettingsPageController.prototype._isUserEntityScopeAll = function (callback) {
        // this.userService.getUserRoleEntityScope((data) => {
        // this.hasAccessToCompanySettings = data.allclientOrBU;
        this.hasAccessToCompanySettings = true;
        if (callback) {
            callback();
        }
        // }, (error) => {
        //     if(callback) {
        //         callback();
        //     }
        // });
    };
    SettingsPageController.prototype._getSettingsForStaffingOrCorporateCompany = function () {
        var _this = this;
        this.loadingFlag = true;
        this.isStillProcessingModified = true;
        this.settingService.getCorporateOrStaffingCompanySettings(this.$rootScope.userDetails.company.companyId, function (data) {
            _this._massageCompanySettings(data);
            if (!(_this.showClientsOrBusList)) {
                _this.$timeout(function () {
                    if (!_this.isValuesInitialized) {
                        _this.setSliderValues();
                        _this.isValuesInitialized = true;
                    }
                    _this.loadingFlag = false;
                }, 500);
            }
            else {
                _this.loadingFlag = false;
            }
            _this.isStillProcessingModified = false;
            if (!_this.isInHost) {
                _this.changeCompanySettings();
            }
            ;
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    SettingsPageController.prototype._massageCompanySettings = function (settings) {
        this.settings = settings;
        this._setReminderSettings();
        this.settingsCopyForCompany = angular.copy(settings);
        for (var i = 0; i < this.settings.performanceSetting.length; i++) {
            this.settings.performanceSetting[i].duplicateMaxLImit = this.settings.performanceSetting[i].maxLimit;
            this.settings.performanceSetting[i].isSelected = false;
            this.settings.performanceSetting[i].isError = false;
        }
        this.toggleParentAndChildSettings = angular.copy(this.settings);
        this.savedSettings = angular.copy(this.settings);
    };
    SettingsPageController.prototype.manageClientOrBuSelection = function () {
        var _this = this;
        this.isCompanySelected = false;
        this.loadingFlag = true;
        if (this.globalSettingsClientModel) {
            this.isStillProcessing = false;
        }
        else {
            this.isStillProcessing = true;
        }
        this.companySelectionActive = false;
        this.globalSettingsCompanyModel = false;
        this.globalSettingsClientModel = false;
        this.showClientsOrBusList = true;
        this.isClientCopyObject = false;
        this.clientCopyMandatoryMessage = false;
        if (this.copyChecked) {
            document.getElementById("checkbox-inl-1").checked = false;
            this.copyChecked = false;
        }
        //this.client = null;
        if (this.allClientsOrBus.length === 0) {
            this._getClientsOrBus(function () {
                if (_this.allClientsOrBus.length > 0) {
                    if (_this.toggleClientValue && _this.toggleClientValue.company) {
                        if (_this.toggleClientValue.company.companyType === "Client") {
                            _this.selectedClientNameForMessage = _this.toggleClientValue.company.name;
                        }
                        else if (_this.toggleClientValue.company.companyType === "BusinessUnit") {
                            _this.selectedBUNameForMessage = _this.toggleClientValue.company.name;
                        }
                        if (_this.showClientsOrBusList && _this.client != null && _this.copyChecked && _this.toggleClientValueCopy.company) {
                            if (_this.toggleClientValueCopy.company.companyType === "Client") {
                                _this.selectedClientNameForMessageCopy = _this.toggleClientValueCopy.company.name;
                            }
                            else if (_this.toggleClientValueCopy.company.companyType === "BusinessUnit") {
                                _this.selectedBUNameForMessageCopy = _this.toggleClientValueCopy.company.name;
                            }
                        }
                    }
                }
                else {
                    _this.loadingFlag = false;
                }
            });
        }
        else {
            this.getSettingsForClient(this.client);
        }
    };
    /**
     * Function Re-Render Sliders values on change of settings;
     */
    SettingsPageController.prototype._updateSettingsInView = function () {
        // console.log('Updating Setings in view');
        for (var i = 0; i < this.settings.licensePreferenceSetting.length; i++) {
            $('.slider-setting-' + i).val(this.settings.licensePreferenceSetting[i].score, true);
            // $('.slider-setting-timeToComplete-' + i).attr("value", this.settings.licensePreferenceSetting[i].timeToComplete);
            $('.slider-setting-timeToComplete-' + i).val(this.settings.licensePreferenceSetting[i].timeToComplete, true);
            if (!this.settings.licensePreferenceSetting[i].isEnabled) {
                //console.log('Disabling: ' + this.settings.licensePreferenceSetting[i].name);
                angular.element('.slider-setting-' + i).attr({ 'disabled': true });
            }
            //$('.slider-setting-' + i).next('span').text($('.slider-setting-' + i).val());
        }
        for (var i = 0; i < this.settings.performanceSetting.length; i++) {
            $('.slider-range-' + i).val([this.settings.performanceSetting[i].minValue, this.settings.performanceSetting[i].maxValue], true);
            this.settings.performanceSetting[i].maxLimit = this.settings.performanceSetting[i].maxLimit;
        }
    };
    SettingsPageController.prototype.isModifyClientSelected = function () {
        return !this.isInHost && !this.companySelectionActive;
    };
    /**
     * Toggle company , client or bu radio button
     */
    SettingsPageController.prototype.manageCompanySelection = function () {
        console.log('Show Staffing/Corporate settings');
        this.isCompanySelected = true;
        this.companySelectionActive = true;
        this.globalSettingsCompanyModel = false;
        this.globalSettingsClientModel = false;
        this.isClientCopyObject = false;
        this.clientCopyMandatoryMessage = false;
        this.allClientsOrBus = [];
        this.isClientGlobalCopy = true;
        // this.$scope.safeApply();
        this.client = null;
        this.copyClientCheckBox = false;
        this.copyChecked = false;
        this.toggleClientValue = {};
        this.showClientsOrBusList = false;
        if (!this.settingsCopyForCompany) {
            this._getSettingsForStaffingOrCorporateCompany();
        }
        else {
            this.settings = angular.copy(this.settingsCopyForCompany);
            this._isGlobalOrCustomSettings();
        }
        this._updateSettingsInView();
    };
    //UI events handler methods
    /**
     * Change company settings type.
     */
    SettingsPageController.prototype.changeCompanySettings = function () {
        this.settings = angular.copy(this.settingsCopyForCompany);
        this.savedSettings = angular.copy(this.settingsCopyForCompany);
        //console.log(angular.equals(this.settings,this.savedSettings));
        this._isGlobalOrCustomSettings();
        this._updateSettingsInView();
        this.globalSettingsCompanyModel = false;
        //this.settings.global = false;
        for (var index = 0; index < this.settings.licensePreferenceSetting.length; index++) {
            if (this.settings.licensePreferenceSetting[index].isEnabled) {
                // console.log('Enabling: ' + this.settings.licensePreferenceSetting[index].name);
                angular.element('.slider-setting-' + index).attr({ 'disabled': false });
                angular.element('.slider-setting-timeToComplete-' + index).attr({ 'disabled': false });
            }
        }
        angular.element('.slider-range').attr({ 'disabled': false });
        angular.element('.onoffswitch').removeClass('avoid-clicks');
        this.selectEnable = false;
        this.isCustomSettingsSelected = true;
    };
    /**
     * Change client settings type.
     */
    SettingsPageController.prototype.changeClientSettings = function () {
        this.isClientCopyObject = false;
        this.clientCopyMandatoryMessage = false;
        this.settings = angular.copy(this.settingsClient);
        this.savedSettings = angular.copy(this.settingsClient);
        //console.log(angular.equals(this.settings,this.savedSettings));
        this._isGlobalOrCustomSettings();
        this._updateSettingsInView();
        this.globalSettingsClientModel = false;
        //this.settings.global = false;
        if (this.copyChecked) {
            document.getElementById("checkbox-inl-1").checked = false;
            this.copyChecked = false;
        }
        for (var index = 0; index < this.settings.licensePreferenceSetting.length; index++) {
            if (this.settings.licensePreferenceSetting[index].isEnabled) {
                angular.element('.slider-setting-' + index).attr({ 'disabled': false });
                angular.element('.slider-setting-timeToComplete-' + index).attr({ 'disabled': false });
            }
        }
        angular.element('.slider-range').attr({ 'disabled': false });
        angular.element('.onoffswitch').removeClass('avoid-clicks');
        this.selectEnable = false;
        this.isCustomSettingsSelected = true;
    };
    /**
     * Global settings at both company and client level.
     */
    SettingsPageController.prototype.changeGlobalSettings = function () {
        this.isClientCopyObject = false;
        this.clientCopyMandatoryMessage = false;
        //console.log(this.copyChecked);
        if (this.copyChecked) {
            document.getElementById("checkbox-inl-1").checked = false;
            this.copyChecked = false;
        }
        //this.settings.global = true;
        // angular.element('.slider-range').attr({ 'disabled': true });
        // angular.element('.noUi-target').attr({ 'disabled': true });
        // angular.element('.onofsfswitch').addClass('avoid-clicks');
        this.isCustomSettingsSelected = false;
        this.selectEnable = true;
        if (!this.companySelectionActive) {
            console.log("Gets settings for Staffing/Corpoarte Company with reference to client.");
            this.globalSettingsClientModel = true;
            this._getParentSettings();
        }
        else {
            console.log("Gets settings for FourDotFive Company.");
            console.log(angular.equals(this.savedSettings, this.settingsCopyForCompany));
            this.globalSettingsCompanyModel = true;
            this._getFourDotFiveSettings(); //Gets settings for FourDotFive Company.
        }
    };
    SettingsPageController.prototype._getParentSettings = function () {
        var _this = this;
        this.settingService.getParentCompanySettings(this.$rootScope.userDetails.company.companyId, function (data) {
            _this.isStillProcessing = true;
            _this.settings = data;
            _this._setReminderSettings();
            for (var i = 0; i < _this.settings.performanceSetting.length; i++) {
                _this.settings.performanceSetting[i].duplicateMaxLImit = _this.settings.performanceSetting[i].maxLimit;
                _this.settings.performanceSetting[i].isSelected = false;
                _this.settings.performanceSetting[i].isError = false;
            }
            _this.toggleParentAndChildSettings = angular.copy(_this.settings);
            _this.savedSettings = angular.copy(_this.settings);
            _this._isGlobalOrCustomSettings();
            _this._updateSettingsInView();
            _this.isStillProcessing = false;
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    /**
     * Change settings type.
     */
    /*this.changeSettingsType = function (settingsType) {
        console.log('Setting type: ' + settingsType);
        if (settingsType === 'globalsettings') {
            this.selectedClientSettings=false;
            this.selectedClientSettingsCopy=false;
            this.selectedCompanySettings=false;
            this.selected4dot5Settings=true;
            this.selectedBUSettings=false;
            this.selectedBUSettingsCopy=false;
            angular.element('.slider-range').attr({ 'disabled': true });
            angular.element('.noUi-target').attr({ 'disabled': true });
            // angular.element('.access').attr({ 'disabled': true });

            angular.element('.onoffswitch').addClass('avoid-clicks');
            this.isCustomSettingsSelected = false;
            this.selectEnable = true;
            if (this.showClientsOrBusList) {
                this._getParentSettings(); //Gets settings for Staffing/Corpoarte Company with reference to client.
                console.log("Gets settings for Staffing/Corpoarte Company with reference to client.");
                this.selected4dot5Settings = false;
                this.selectedCompanySettings = true;
            } else {
                console.log("Gets settings for FourDotFive Company.");
                this._getFourDotFiveSettings();  //Gets settings for FourDotFive Company.
            }
        } else {
//                	this.selectedClientSettings=false;
//                	this.selectedCompanySettings=true;
//                	this.selected4dot5Settings=false;
            this.onClickCompanyModifySettings = true;
            console.log("this.globalSettingsCompanyModel"+this.globalSettingsCompanyModel);
            for (var index = 0; index < this.settings.licensePreferenceSetting.length; index++) {
                if (this.settings.licensePreferenceSetting[index].isEnabled) {
                    console.log('Enabling: ' + this.settings.licensePreferenceSetting[index].name);
                    angular.element('.slider-setting-' + index).attr({ 'disabled': false });
                    angular.element('.slider-setting-timeToComplete-' + index).attr({ 'disabled': false });
                    // angular.element('.dropdowns-for-' + index).attr({ 'disabled': false });
                }
            }
            
            angular.element('.noUi-target').attr({ 'disabled': false });
            angular.element('.access').attr({ 'disabled': false });

            angular.element('.slider-range').attr({ 'disabled': false });
            angular.element('.onoffswitch').removeClass('avoid-clicks');
            this.selectEnable = false;
            this.isCustomSettingsSelected = true;
        }
        console.log('this.isCustomSettingsSelected: ' + this.isCustomSettingsSelected);
    }
*/
    /**
     * This function is called on click of cancel to reset scope variables.
     */
    SettingsPageController.prototype.cancel = function () {
        if (this.companySelectionActive) {
            // this._changeCompanySettingsBeforeSave();
            // if (!angular.equals(this.savedSettings, this.settingsCopyForCompany)) {
            this.settings = angular.copy(this.settingsCopyForCompany);
            this._updateSettingsInView();
            if (!this.isInHost) {
                this.globalSettingsCompanyModel = false;
                this.changeCompanySettings();
            }
            // }
        }
        else if (!this.companySelectionActive) {
            //this._changeClientSettingsBeforeSave();
            //if(!angular.equals(this.savedSettings, this.settingsClient)) {
            this.settings = angular.copy(this.settingsClient);
            this._updateSettingsInView();
            this.globalSettingsClientModel = false;
            this.copyChecked = false;
            //}
            this.changeClientSettings();
        }
    };
    SettingsPageController.prototype.reminderEnabledOrDisabled = function (settingIndex) {
        var reminderSetting = angular.copy(this.settings.licensePreferenceSetting[settingIndex]);
        if (reminderSetting.isReminderEnabled) {
            reminderSetting.reminderInterval = reminderSetting.defaultReminderInterval;
        }
        else {
            reminderSetting.reminderInterval = 0;
        }
        this.settings.licensePreferenceSetting[settingIndex] = angular.copy(reminderSetting);
    };
    SettingsPageController.prototype.onClientOrBuChange = function () {
        var selectedClientOrBu = _.filter(this.allClientsOrBus, { companyId: this.selectedClientOrBu.id })[0];
        this._getClientSettings(selectedClientOrBu);
        if (!this.viewOnlyMode) {
            document.getElementById("checkbox-inl-1").checked = false;
        }
    };
    SettingsPageController.prototype._getClientSettings = function (selectedClient) {
        if (angular.isUndefined(selectedClient)) {
            return;
        }
        else {
            this.getSettingsForClient(selectedClient);
        }
    };
    /**
     * This function is to get setting from the client from which settings are to be copied.
     */
    SettingsPageController.prototype.getSettingsForClientToCopy = function (clientCopy) {
        var _this = this;
        if (clientCopy) {
            this.isStillProcessing = true;
            this.toggleClientValueCopy = clientCopy;
            this.isClientCopyObject = true;
            this.clientCopyMandatoryMessage = false;
            if (clientCopy.company.companyType === "Client" || clientCopy.company.companyType === "Corporation") {
                this.selectedClientNameForMessageCopy = clientCopy.company.name;
            }
            else if (clientCopy.company.companyType === "BusinessUnit") {
                this.selectedBUNameForMessageCopy = clientCopy.company.name;
            }
            this.clientCopy = clientCopy;
            if (angular.isDefined(clientCopy)) {
                this.loadingFlag = true;
                this.settingService.getClientOrBuSettings(this.$rootScope.userDetails.company.companyId, clientCopy.company.id, function (data) {
                    _this.settings = data;
                    _this._setReminderSettings();
                    _this.savedSettings = data;
                    _this._isGlobalOrCustomSettings();
                    _this._updateSettingsInView();
                    _this.loadingFlag = false;
                }, function (error) {
                    if (_this.$rootScope.isOnline) {
                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                });
            }
            //this.isStillProcessing = false;
        }
    };
    SettingsPageController.prototype.setSettings = function () {
        if (this.companySelectionActive) {
            this._setSettingsForCompany();
        }
        else {
            this._setSettingsForClientOrBU();
        }
    };
    SettingsPageController.prototype._setSettingsForCompany = function () {
        var _this = this;
        console.log("ENtered set settings for company");
        this._changeCompanySettingsBeforeSave();
        if (!this.settingsCopyForCompany.global && angular.equals(this.savedSettings, this.settingsCopyForCompany)) {
            //Nothing to be saved.
            console.log('Nothing to be saved for company.');
            this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.NOTHING_TO_SAVE, 'success');
        }
        else if (!this.isInHost && this.globalSettingsCompanyModel) {
            console.log('Delete global for company and save new settings for company.' + angular.toJson(this.$rootScope.userDetails.company));
            this.settingService.deleteStaffingOrCorpSettings(this.$rootScope.userDetails.company.companyId, function (data) {
                console.log('Deleted Custom Settings company: ' + angular.toJson(data));
                _this.globalSettingsCompanyModel = false;
                _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.SETTINGS.SETTINGS_FOR_COMPANY + " '<b><i class='wrap-word'>" + _this.$rootScope.userDetails.company.companyName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.SETTINGS.UPDATE_SUCCESS, 'success');
                _this.settingService.getCorporateOrStaffingCompanySettings(_this.$rootScope.userDetails.company.companyId, function (data) {
                    _this._massageCompanySettings(data);
                }, function (error) {
                    if (_this.$rootScope.isOnline) {
                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                    _this.$state.go('missioncontrol.dashboard', null, { reload: true });
                });
            }, function (error) {
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
                _this.cancel();
            });
        }
        else if ((this.settingsCopyForCompany.global || !angular.equals(this.savedSettings, this.settingsCopyForCompany))) {
            console.log('Update custom settings for company.');
            this.settingService.setCompanySettings(this.$rootScope.userDetails.company.companyId, this.savedSettings, function (response) {
                console.log('Update Custom Settings : ' + angular.toJson(response));
                _this.settingService.getCorporateOrStaffingCompanySettings(_this.$rootScope.userDetails.company.companyId, function (data) {
                    _this.settings = data;
                    _this._setReminderSettings();
                    _this.settingsCopyForCompany = angular.copy(_this.settings);
                    _this.savedSettings = angular.copy(_this.settings);
                    if (!_this.isInHost) {
                        //                    	     this.modifySettingsCompanyModel=false;
                        //                           this.globalSettingsCompanyModel=false;
                        //                           document.getElementById('modifySettingsCompany').checked = false;
                        //                           document.getElementById('globalSettingsCompany').checked = false;
                        _this.toggleParentAndChildSettings = angular.copy(_this.settings);
                    }
                    else {
                        _this.settingsCopy = data;
                        _this.globalSettings = angular.copy(_this.settings);
                    }
                    _this.alertsAndNotificationsService.showBannerMessage(response.message, 'success');
                }, function (error) {
                    if (_this.$rootScope.isOnline) {
                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                });
            }, function (error) {
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
                _this.cancel();
            });
        }
    };
    SettingsPageController.prototype._changeCompanySettingsBeforeSave = function () {
        this.savedSettings = angular.copy(this.settings);
        //Update custom settings.
        for (var i = 0; i < this.settings.performanceSetting.length; i++) {
            delete this.settings.performanceSetting[i].duplicateMaxLImit;
            delete this.settings.performanceSetting[i].isSelected;
            delete this.settings.performanceSetting[i].isError;
            delete this.settings.performanceSetting[i].isErrorForMax;
            delete this.savedSettings.performanceSetting[i].duplicateMaxLImit;
            delete this.savedSettings.performanceSetting[i].isSelected;
            delete this.savedSettings.performanceSetting[i].isError;
            delete this.savedSettings.performanceSetting[i].isErrorForMax;
        }
        for (var j = 0; j < this.settings.performanceSetting.length; j++) {
            var minMaxValues_1 = $('.slider-range-' + j).val();
            this.savedSettings.performanceSetting[j].minValue = Number(minMaxValues_1[0]);
            this.savedSettings.performanceSetting[j].maxValue = Number(minMaxValues_1[1]);
        }
        //Updating the score values from view.
        for (var j = 0; j < this.settings.licensePreferenceSetting.length; j++) {
            if (this.settings.licensePreferenceSetting[j].score != null) {
                this.savedSettings.licensePreferenceSetting[j].score = Number($('.slider-setting-' + j).val());
            }
            // console.log( this.savedSettings.licensePreferenceSetting[j].score, this.settings.licensePreferenceSetting[j].score);
        }
        //Updating the time to complete days from view.
        for (var j = 0; j < this.settings.licensePreferenceSetting.length; j++) {
            if (this.settings.licensePreferenceSetting[j].timeToComplete != null) {
                this.savedSettings.licensePreferenceSetting[j].timeToComplete = Number($('.slider-setting-timeToComplete-' + j).val());
            }
        }
        if (this.isInHost) {
            console.log("Entered license preference host");
            var minMaxValues;
            //Updating the range values from view.
            for (var j = 0; j < this.settings.performanceSetting.length; j++) {
                console.log("Entered license preference host");
                minMaxValues = $('.slider-range-' + j).val();
                this.savedSettings.performanceSetting[j].minValue = Number(minMaxValues[0]);
                this.savedSettings.performanceSetting[j].maxValue = Number(minMaxValues[1]);
            }
        }
    };
    /**
     * This function is to set Settings for the Staffing/Corporate company or Client/Bu.
     */
    SettingsPageController.prototype._setSettingsForClientOrBU = function () {
        var _this = this;
        if (!((this.client != null) && this.copyChecked && (this.clientCopy === null))) {
            this._changeClientSettingsBeforeSave();
            this.clientCopyMandatoryMessage = false;
            if (!this.settingsClient.global && angular.equals(this.savedSettings, this.settingsClient)) {
                //Nothing to be saved.
                this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.NOTHING_TO_SAVE, 'success');
            }
            else if (this.globalSettingsClientModel) {
                var clientDetails = {
                    isClientCompanySettingsActivity: this.client.companyType == 'Corporation'
                };
                //Delete global for client and save new settings for client.
                this.settingService.deleteClientOrBuSettings(this.$rootScope.userDetails.company.companyId, this.client.companyId, clientDetails, function (data) {
                    console.log('Deleted Custom Settings : ' + angular.toJson(data));
                    console.log('Deleted Custom Settings : ' + angular.toJson(_this.client));
                    _this.globalSettingsClientModel = false;
                    _this._changeClientName();
                    _this.getSettingsForClient(_this.client);
                    _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.SETTINGS.SETTINGS_FOR + '' + _this.client.companyType + " '<b><i class='wrap-word'>" + _this.client.companyName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.SETTINGS.UPDATE_SUCCESS, 'success');
                }, function (error) {
                    if (_this.$rootScope.isOnline) {
                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                    _this.cancel();
                });
            }
            else if ((this.settingsClient.global || !angular.equals(this.savedSettings, this.settingsClient))) {
                //Update custom settings.
                console.log('Update custom settings for client.');
                this.settingService.setClientOrBuSettings(this.$rootScope.userDetails.company.companyId, this.client.companyId, this.savedSettings, function (data) {
                    console.log('Update Custom Settings : ' + angular.toJson(data));
                    //                        this.modifySettingsClientModel=false;
                    //                        this.globalSettingsClientModel=false;
                    //                        document.getElementById('modifySettingsClient').checked = false;
                    //                        document.getElementById('globalSettingsClient').checked = false;
                    if (_this.copyChecked) {
                        document.getElementById("checkbox-inl-1").checked = false;
                        _this.copyChecked = false;
                    }
                    _this.settings = data;
                    _this._setReminderSettings();
                    _this.isClientGlobal = data.global;
                    _this.isClientGlobalCopy = _this.isClientGlobal;
                    _this.settingsClient = angular.copy(_this.settings);
                    _this.savedSettings = angular.copy(_this.settings);
                    _this.isClientCopyObject = false;
                    _this.clientCopyMandatoryMessage = false;
                    _this._changeClientName();
                    _this.alertsAndNotificationsService.showBannerMessage(data.message, 'success');
                }, function (error) {
                    if (_this.$rootScope.isOnline) {
                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                    _this.cancel();
                });
            }
        }
        else {
            this._showCopyClientValidationAlert();
            //this.clientCopyMandatoryMessage = true;
        }
    };
    SettingsPageController.prototype._changeClientSettingsBeforeSave = function () {
        this.savedSettings = angular.copy(this.settings);
        for (var i = 0; i < this.settings.performanceSetting.length; i++) {
            delete this.settings.performanceSetting[i].duplicateMaxLImit;
            delete this.settings.performanceSetting[i].isSelected;
            delete this.settings.performanceSetting[i].isError;
            delete this.savedSettings.performanceSetting[i].duplicateMaxLImit;
            delete this.savedSettings.performanceSetting[i].isSelected;
            delete this.savedSettings.performanceSetting[i].isError;
        }
        for (var j = 0; j < this.settings.performanceSetting.length; j++) {
            var minMaxValues = $('.slider-range-' + j).val();
            this.savedSettings.performanceSetting[j].minValue = Number(minMaxValues[0]);
            this.savedSettings.performanceSetting[j].maxValue = Number(minMaxValues[1]);
        }
        //Updating the score values from view.
        for (var j = 0; j < this.settings.licensePreferenceSetting.length; j++) {
            if (this.settings.licensePreferenceSetting[j].score != null) {
                this.savedSettings.licensePreferenceSetting[j].score = Number($('.slider-setting-' + j).val());
            }
            // console.log( this.savedSettings.licensePreferenceSetting[j].score, this.settings.licensePreferenceSetting[j].score);
        }
        //Updating the time to complete days from view.
        for (var j = 0; j < this.settings.licensePreferenceSetting.length; j++) {
            if (this.settings.licensePreferenceSetting[j].timeToComplete != null) {
                this.savedSettings.licensePreferenceSetting[j].timeToComplete = Number($('.slider-setting-timeToComplete-' + j).val());
            }
        }
    };
    SettingsPageController.prototype._changeClientName = function () {
        var _this = this;
        this.userService.getUsersOnlyClientsOrBus(this.$rootScope.userDetails.company.companyId, function (data) {
            _this.clientsOrBUsList = data;
            for (var i = 0; i < _this.clientsOrBUsList.length; i++) {
                for (var k = 0; k < _this.allClientsOrBus.length; k++) {
                    if (_this.allClientsOrBus[k].companyId === _this.clientsOrBUsList[i].companyId) {
                        _this.allClientsOrBus[k].aliasName = _this.clientsOrBUsList[i].aliasName;
                        if (_this.allClientsOrBus[k].companyId === _this.client.companyId) {
                            _this.client.aliasName = _this.allClientsOrBus[k].aliasName;
                        }
                    }
                }
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    SettingsPageController.prototype._showCopyClientValidationAlert = function () {
        if (this.isStaffingCompany) {
            var copyMessage = 'Please select a Client to copy from.';
        }
        else {
            var copyMessage = 'Please select a BU to copy from.';
        }
        bootbox.alert({
            closeButton: false,
            title: '<div class="alert alert-danger"><i class="fa fa-times-circle fa-fw fa-lg"></i><strong>Oh snap!</strong></div>',
            message: copyMessage,
            callback: function () {
            }
        });
    };
    /**
     * This function is to get all the clients/bus for the Staffing/Corporate company.
     */
    SettingsPageController.prototype._getClientsOrBusHavingCustomSettings = function () {
        var _this = this;
        this.isStillProcessing = true;
        this.loadingFlag = true;
        console.log('Getting Clients/Bus with custom settings');
        this.companyService.getClientsOrBusHavingCustomSettings(this.$rootScope.userDetails.company.companyId, function (data) {
            console.log('Getting Clients/Bus with custom settings api success');
            data.length == 0 ? _this.copyClientCheckBox = false : '';
            _this.availableClientsToCopy = [];
            data.forEach(function (element) {
                if (element.company.id != _this.client.companyId) {
                    _this.availableClientsToCopy.push(element);
                    //console.log(this.availableClientsToCopy.length)
                    _this.copyClientCheckBox = true;
                }
                else {
                    //                            console.log('Duplicate : ' + element.company.name + ' not added');
                }
            }, _this);
            if (_this.availableClientsToCopy.length < 1) {
                _this.copyClientCheckBox = false;
            }
            _this.isStillProcessing = false;
            console.log('loaded available clients to copy dropdown');
            _this.loadingFlag = false;
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    /**
     * Function to this.cancel(hide the save and cancel buttons that appear on edit of maxlimit).
     */
    SettingsPageController.prototype.cancelTimeForSliders = function (rangeSlider) {
        this.settings.performanceSetting[rangeSlider].isSelected = false;
        this.settings.performanceSetting[rangeSlider].isError = false;
        this.settings.performanceSetting[rangeSlider].isErrorForMax = false;
        this.settings.performanceSetting[rangeSlider].duplicateMaxLImit = this.settings.performanceSetting[rangeSlider].maxLimit;
    };
    /**
     * Function to toggle edit options for range sliders.
     */
    SettingsPageController.prototype.toggleEditOptionForSliders = function (rangeSliderIndex) {
        //   console.log('Edit Range maxlimit: ' + rangeSliderIndex);
        this.settings.performanceSetting[rangeSliderIndex].duplicateMaxLImit = this.settings.performanceSetting[rangeSliderIndex].maxLimit;
        this.settings.performanceSetting[rangeSliderIndex].isSelected = true;
    };
    SettingsPageController.prototype.isCopyChecked = function () {
        //this.modifySettingsClientModel=false;
        this.globalSettingsClientModel = false;
        this.isClientCopyObject = false;
        this.clientCopyMandatoryMessage = false;
        this.availableClientsToCopy = [];
        this.clientCopy = null;
        this.copyChecked = document.getElementById("checkbox-inl-1").checked;
        if (this.copyChecked) {
            this._getClientsOrBusHavingCustomSettings();
        }
        else {
            this.settings = angular.copy(this.settingsClient);
            this.savedSettings = angular.copy(this.settingsClient);
            this._isGlobalOrCustomSettings();
            this._updateSettingsInView();
        }
        /*this.allClientsOrBus.forEach(function (element) {
            if (element.company.id != this.client.company.id) {
                this.availableClientsToCopy.push(element);
            } else {
                console.log('Duplicate : ' + element.company.name + ' not added');
            }
        }, this);*/
        //                this.$timeout(function () {
        //                   // console.log('Items to copy array: ' + angular.toJson(this.availableClientsToCopy));
        //                    if(this.copyChecked){
        //                    	this.clientCopy = this.availableClientsToCopy[0];
        //                    	this.getSettingsForClientToCopy(this.clientCopy);
        //                    }else{
        //                    	this.getSettingsForClient(this.client);
        //                    }
        //                }, 50)
    };
    SettingsPageController.prototype.onMetricsValueChange = function (metricsEnum, changedTo, metricIndex, metricStepIndex) {
        var minValue = 0;
        var maxValue = 100;
        if (metricsEnum == "TIME_IN_WORKFLOW_STEP") {
            maxValue = 50;
        }
        if (changedTo == undefined) {
            changedTo = 0;
        }
        else if (changedTo > maxValue) {
            changedTo = maxValue;
        }
        else if (changedTo < minValue) {
            changedTo = minValue;
        }
        this.settings.metricsForWorkflowSteps[metricIndex].steps[metricStepIndex].value = changedTo;
    };
    SettingsPageController.prototype.isSectionActive = function () {
        if (this.isInHost) {
            return true;
        }
        else {
            if (this.globalSettingsClientModel || this.globalSettingsCompanyModel || this.viewOnlyMode) {
                return false;
            }
            else {
                return true;
            }
        }
    };
    //            this.$scope.$on('$stateChangeStart', function (event, toState, fromState, toParams) {
    //                console.log('Moving out.................');
    //                this.StorageService.remove('removeSliderId');
    //                this.StorageService.set('outOfPage', 'movingOut');
    //            });
    SettingsPageController.prototype._handleDisableSlider = function () {
        var _this = this;
        $('#disable-checkbox').click(function () {
            if (_this.checked) {
                // Disable the slider
                disableSlider.attr("disabled", "disabled");
            }
            else {
                // Enabled the slider
                disableSlider.removeAttr("disabled");
            }
        });
    };
    //Handle navigating away when data is unsaved
    SettingsPageController.prototype.uiCanExit = function (transitions) {
        var _this = this;
        var toState = transitions.to().name;
        var toParams = transitions.params();
        if (this._isSettingsChanged() && toState !== "login") {
            transitions.abort();
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
                message: "Unsaved data on the page will be lost. Do you still want to continue?",
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: function (result) {
                    if (result) {
                        _this.cancel();
                        _this.StorageService.remove('removeSliderId');
                        _this.StorageService.set('outOfPage', 'movingOut');
                        _this.StorageService.remove('wizardoperations');
                        // Handling data change when clicked on Switch company
                        if (_this.$rootScope.switchClicked) {
                            _this.$rootScope.switchClicked = false;
                            // this.companyService.showAllCompanies();
                            _this.uibModalService.showAllCompanies();
                        }
                        else {
                            _this.$state.go(toState, toParams, { reload: true });
                        }
                    }
                    else {
                        if (_this.$rootScope.switchClicked) {
                            _this.$rootScope.switchClicked = false;
                        }
                    }
                }
            });
        }
        else {
            // If clicked on switch company without changing data
            if (this.$rootScope.switchClicked && !this._isSettingsChanged()) {
                transitions.abort();
                this.$timeout(function () {
                    // this.companyService.showAllCompanies();
                    _this.uibModalService.showAllCompanies();
                }, 150);
                this.$rootScope.switchClicked = false;
            }
        }
    };
    SettingsPageController.prototype._handleBrowserBackForwardChange = function () {
        var _this = this;
        var unbindLocationChangeEvent = this.$scope.$on('$locationChangeStart', function (event, toState, toParams, fromState, fromParams) {
            _this.isLocationChange = _this.isLocationChangeInitial;
            _this.isLocationChangeInitial = true;
        });
    };
    /**
     * UNbind state for Warning message pop
     */
    SettingsPageController.prototype._isSettingsChanged = function () {
        if (this.companySelectionActive) {
            this._changeCompanySettingsBeforeSave();
            if ((angular.equals(this.savedSettings, this.settingsCopyForCompany)) || (!this.isInHost && this.globalSettingsCompanyModel && !angular.equals(this.savedSettings, this.settingsCopyForCompany))) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            this._changeClientSettingsBeforeSave();
            if (this.allClientsOrBus.length > 0) {
                if ((angular.equals(this.savedSettings, this.settingsClient)) || (this.globalSettingsClientModel && !angular.equals(this.savedSettings, this.settingsClient))) {
                    return false;
                }
                else {
                    return true;
                }
            }
            else {
                return false;
            }
        }
    };
    SettingsPageController.prototype._getAllActivityTypes = function () {
        var _this = this;
        this.jobService.getActivityTypes(function (data) {
            _this.activityMap = [];
            angular.forEach(data, function (val, key) {
                _this.activityMap[val.value] = val.name;
            });
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    SettingsPageController.prototype.viewActivities = function () {
        var _this = this;
        var companyId = null;
        var context = "companySettings";
        var isSharedClient = false;
        if (this.isCompanySelected) {
            companyId = this.$rootScope.userDetails.company.companyId;
        }
        else if (this.selectedClientOrBu.id !== null) {
            companyId = this.selectedClientOrBu.id;
            context = "clientOrBuSettings";
            isSharedClient = this.client.companyType == 'Corporation';
        }
        var actionType = 'activities';
        var actionLabel = "Setting Activities";
        var modalWindowClass = "four-dot-five-modal-medium";
        var actionsModal = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            windowClass: modalWindowClass,
            component: 'settingsActionsModal',
            resolve: {
                actionType: function () {
                    return actionType;
                },
                actionLabel: function () {
                    return actionLabel;
                },
                activityMap: function () {
                    return _this.activityMap;
                },
                companyId: function () {
                    return companyId;
                },
                isSharedClient: function () {
                    return isSharedClient;
                },
                context: function () {
                    return context;
                }
            }
        });
    };
    SettingsPageController.prototype.isOutReachSettingEditable = function () {
        return this.settings.outReachSetting && ((this.isInHost && this.settings.outReachSetting.enabled)
            || (!this.isInHost && this.settings.outReachSetting.enabled && this.settings.hostOrParentEnabled));
    };
    return SettingsPageController;
}());
export { SettingsPageController };
SettingsPageController.$inject = ['$scope', '$state', '$rootScope', '$timeout', '$window', '$transitions', '$uibModal', 'StorageService', 'jobService', 'settingService', 'userService', 'companyService', 'utilityService', 'alertsAndNotificationsService', 'MESSAGECONSTANTS', 'uibModalService', 'userRoleService'];
// import * as TEMPLATE from './settings-page.html';
import * as TEMPLATE from 'raw-loader!./settings-page.html';
export var SettingsPageComponent = {
    selector: 'settingsPage',
    component: {
        bindings: { $transition$: '<' },
        // templateUrl: 'app/partials/missioncontrol/settings/settings-page.html',
        template: TEMPLATE.default,
        controller: SettingsPageController
    }
};
//# sourceMappingURL=settings-page.component.js.map